import React from "react";
import Splogo from '../../assets/sp-logo.jpg'
function Logo(){
    return (
        <>
        <img src={Splogo} alt="logo"  className='w-40'/>
        </>
    )
} 
export default Logo